import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white relative overflow-hidden">
      {/* World Map Background */}
      <div className="absolute inset-0 opacity-5">
        <div className="w-full h-full" style={{ 
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3E%3Cpath fill='none' stroke='white' stroke-width='1' d='M200,100 L250,120 L280,110 L320,130 L350,115 M400,150 L450,170 L500,160 L550,180 M600,200 L650,220 L700,210 L750,230 M800,180 L850,200 L900,190 L950,210'/%3E%3C/svg%3E")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}></div>
      </div>

      <div className="relative z-10 px-6 md:px-20 py-20">
        <div className="max-w-7xl mx-auto">
          {/* Top Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
            {/* Brand Column */}
            <div className="lg:col-span-1">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-lg">
                  <i className="ri-global-line text-xl text-white"></i>
                </div>
                <span className="text-xl font-bold tracking-tight">
                  GAIA LIBRARY
                </span>
              </div>
              <p className="text-sm leading-relaxed text-white/80 mb-6">
                テクノロジーで、<br />
                アジアと地域の暮らしを<br />
                もっと豊かに。
              </p>
            </div>

            {/* Navigation Columns */}
            <div>
              <h3 className="text-base font-bold mb-4">事業内容</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/business" className="text-sm text-white/80 hover:text-white hover:underline transition-all cursor-pointer">
                    ステーブルコイン事業
                  </Link>
                </li>
                <li>
                  <Link to="/business" className="text-sm text-white/80 hover:text-white hover:underline transition-all cursor-pointer">
                    輸入事業
                  </Link>
                </li>
                <li>
                  <Link to="/business" className="text-sm text-white/80 hover:text-white hover:underline transition-all cursor-pointer">
                    クラティブ
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-base font-bold mb-4">企業情報</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/vision" className="text-sm text-white/80 hover:text-white hover:underline transition-all cursor-pointer">
                    Our Vision
                  </Link>
                </li>
                <li>
                  <Link to="/company" className="text-sm text-white/80 hover:text-white hover:underline transition-all cursor-pointer">
                    会社概要
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-sm text-white/80 hover:text-white hover:underline transition-all cursor-pointer">
                    お問い合わせ
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-base font-bold mb-4">テクノロジー</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/technology" className="text-sm text-white/80 hover:text-white hover:underline transition-all cursor-pointer">
                    Blockchain
                  </Link>
                </li>
                <li>
                  <Link to="/technology" className="text-sm text-white/80 hover:text-white hover:underline transition-all cursor-pointer">
                    AI / AIエージェント
                  </Link>
                </li>
                <li>
                  <Link to="/usecase" className="text-sm text-white/80 hover:text-white hover:underline transition-all cursor-pointer">
                    DX効果
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-white/20">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              {/* Copyright */}
              <p className="text-sm text-white/70">
                © 2025 GAIA LIBRARY. All rights reserved.
              </p>

              {/* Social Icons */}
              <div className="flex items-center gap-4">
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg text-white hover:bg-white hover:text-blue-900 transition-all duration-300 cursor-pointer"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg text-white hover:bg-white hover:text-blue-900 transition-all duration-300 cursor-pointer"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-x-fill text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg text-white hover:bg-white hover:text-blue-900 transition-all duration-300 cursor-pointer"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg text-white hover:bg-white hover:text-blue-900 transition-all duration-300 cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
              </div>

              {/* Quick Link */}
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
